export default function Marquee({ text }) {
  const items = Array(6).fill(text);
  const Row = ({ hidden }) => (
    <div aria-hidden={hidden} className="flex shrink-0 items-center">
      {items.map((t, i) => (
        <span
          key={i}
          className="flex items-center whitespace-nowrap font-display text-sm font-bold uppercase tracking-[0.3em] text-slate-500"
        >
          {t}
          <span className="mx-2 inline-block h-1.5 w-1.5 rotate-45 bg-[#00F562]" />
        </span>
      ))}
    </div>
  );

  return (
    <div
      data-testid="editorial-marquee"
      className="relative overflow-hidden border-y border-white/[0.06] bg-[#0D111A]/60 py-5"
    >
      <div className="th-marquee-track flex w-max">
        <Row hidden={false} />
        <Row hidden={true} />
      </div>
    </div>
  );
}
